import { render } from "./extInfo.vue?vue&type=template&id=5c58af9c&scoped=true"
import script from "./extInfo.vue?vue&type=script&lang=js"
export * from "./extInfo.vue?vue&type=script&lang=js"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c58af9c"]])

export default __exports__